var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeaderTab',{attrs:{"title":_vm.$t('global.gestion_residences')}}),_c('div',{attrs:{"id":"content"}},[_c('ShutterPanel')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }